export default "__VITE_PUBLIC_ASSET__60bc6077__"